import Link from "next/link";
import { VFC } from "react";
import { Member, Payment } from "../../types/types";
import { StepProgressBar } from "./StepProgressBar";

interface StepProps {
  step: number;
  user: Member;
  payment: Payment;
}

export const Step4: VFC<StepProps> = ({ step, user, payment }) => {
  return (
    <>
      <div className="l-container">
        <StepProgressBar step={step} />

        <div className="p-pageTtl">
          <div className="p-pageTtl__inner">
            <h2 className="p-pageTtl__ttl">ご確認</h2>
          </div>
        </div>
      </div>

      <div className="l-container">
        <div className="p-formConf">
          <div className="p-formConf__inner">
            <div className="p-formConf__item">
              <p className="p-formConf__label">寄付の方法</p>
              <div className="p-formConf__value">
                <p>
                  {payment.isPeriodic
                    ? "マンスリーサポーター（毎月・定額）"
                    : "今回（１回）のみ寄付"}
                </p>
              </div>
            </div>
            <hr />
            <h3 className="p-formConf__ttl">基本情報</h3>
            {user.company_flag ? (
              <div className="p-formConf__item">
                <p className="p-formConf__label">法人名</p>
                <div className="p-formConf__value">
                  <p>{user.name}</p>
                </div>
              </div>
            ) : (
              <></>
            )}
            <div className="p-formConf__item">
              <p className="p-formConf__label">
                {user.company_flag ? "ご担当者名" : "氏名"}
              </p>
              <div className="p-formConf__value">
                <p>{user.name}</p>
              </div>
            </div>
            <div className="p-formConf__item">
              <p className="p-formConf__label">郵便番号</p>
              <div className="p-formConf__value">
                <p>{user.zip_code}</p>
              </div>
            </div>
            <div className="p-formConf__item">
              <p className="p-formConf__label">都道府県</p>
              <div className="p-formConf__value">
                <p>{user.region}</p>
              </div>
            </div>
            <div className="p-formConf__item">
              <p className="p-formConf__label">住所</p>
              <div className="p-formConf__value">
                <p>{user.address}</p>
              </div>
            </div>
            <div className="p-formConf__item">
              <p className="p-formConf__label">電話番号</p>
              <div className="p-formConf__value">
                <p>{user.phone_number}</p>
              </div>
            </div>
            <div className="p-formConf__item">
              <p className="p-formConf__label">メールアドレス</p>
              <div className="p-formConf__value">
                <p>{user.email_address}</p>
              </div>
            </div>
            <div className="p-formConf__item">
              <p className="p-formConf__label">領収書の有無</p>
              <div className="p-formConf__value">
                <p>{user.receipt ? "必要" : "不要"}</p>
              </div>
            </div>
            <div className="p-formConf__item">
              <p className="p-formConf__label">領収書の宛名</p>
              <div className="p-formConf__value">
                <p>{user.receipt_address}</p>
              </div>
            </div>
            <div className="p-formConf__item">
              <p className="p-formConf__label">お申し込みのきっかけ</p>
              <div className="p-formConf__value">
                <p>{user.motivation}</p>
              </div>
            </div>
            <hr />
            <h3 className="p-formConf__ttl">お支払い方法</h3>
            <div className="p-formConf__item">
              <p className="p-formConf__label">お支払い方法</p>
              <div className="p-formConf__value">
                <p>
                  {payment.method == "credit" ? "クレジットカード" : "銀行振込"}
                </p>
              </div>
            </div>
            {/*
            <div className="p-formConf__item">
              <p className="p-formConf__label">カード番号（半角数字）</p>
              <div className="p-formConf__value">
                <p>0000************</p>
              </div>
            </div>
             <div className="p-formConf__item">
              <p className="p-formConf__label">有効期限</p>
              <div className="p-formConf__value">
                <p>00/00</p>
              </div>
            </div>
            <div className="p-formConf__item">
              <p className="p-formConf__label">セキュリティコード</p>
              <div className="p-formConf__value">
                <p>***</p>
              </div>
            </div> */}
            {payment.method == "credit" ? (
              <div className="p-formConf__item">
                <p className="p-formConf__label">寄付金額</p>
                <div className="p-formConf__value">
                  <p>¥{payment.amount.toLocaleString()}</p>
                  {payment.transfer_fee_flag ? (
                    <p>
                      決済手数料3.6%+税（
                      {Math.ceil(payment.amount / 0.964 - payment.amount)}
                      円）を追加で負担して寄付する
                    </p>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
